import { create } from 'zustand';
import { LOGOUT_RESET, StyleOptions, Voiceover } from 'shared';
import { persist, createJSONStorage } from 'zustand/middleware';

type VideoState = {
  videoTitle: string;
  currentStyle: StyleOptions;
  scriptText: string;
  voiceover: Voiceover | null;
  backgroundColor: string;
  parentId: string | null;
};

type VideoActions = {
  setVideoTitle: (newTitle: string) => void;
  setStyle: (newStyle: StyleOptions) => void;
  setScriptText: (newScriptText: string) => void;
  setVoiceover: (newVoiceover: Voiceover | null) => void;
  setBackgroundColor: (newColor: string) => void;
  setParentId: (parentId: string | null) => void;
  resetStore: () => void;
};

export type VideoStore = VideoState & VideoActions;

window.addEventListener(LOGOUT_RESET, () => {
  videoStore.getState().resetStore();
});

export const videoStore = create(
  persist<VideoStore>(
    (set) => ({
      videoTitle: '',
      setVideoTitle: (newTitle) => set({ videoTitle: newTitle }),
      currentStyle: 'friendly',
      setStyle: (newStyle) => set({ currentStyle: newStyle }),
      scriptText: '',
      setScriptText: (newScriptText) =>
        set({ scriptText: newScriptText, voiceover: null }),
      voiceover: null,
      setVoiceover: (newVoiceover) => {
        set({ voiceover: newVoiceover, scriptText: '' });
      },
      backgroundColor: '#ffffff',
      setBackgroundColor: (newColor) => set({ backgroundColor: newColor }),
      parentId: null,
      setParentId: (parentId) => set({ parentId }),
      resetStore: () => {
        set({
          videoTitle: '',
          currentStyle: 'friendly',
          scriptText: '',
          voiceover: null,
          backgroundColor: '#ffffff',
          parentId: null
        });
      }
    }),
    {
      name: 'video-store',
      storage: createJSONStorage(() => localStorage),
      merge: (persistedState, currentState) => {
        const processedPersistedState = persistedState as VideoStore;
        if (processedPersistedState.voiceover) {
          const audio = new Audio(processedPersistedState.voiceover.link);
          audio.onloadedmetadata = () => {
            currentState.setVoiceover({
              name: processedPersistedState.voiceover?.name ?? '',
              link: processedPersistedState.voiceover?.link ?? '',
              audio
            });
          };
        }
        return {
          ...currentState,
          ...processedPersistedState
        };
      }
    }
  )
);
